const draggable = "_35sdhklqok";

export { draggable };
import "./atom.draggable.style.linaria.module.css";
//# sourceMappingURL=atom.draggable.style.js.map
